import actions from './actions';

const initState = { headerKeys: null, contentKeys: null };

export default function dashboardReducer(state = initState, action) {
  switch (action.type) {
    case actions.WIDGET_UPDATE_SUCCESS:
      return {
        ...state,
        headerKeys: action.headerKeys,
        contentKeys: action.contentKeys,
      };
    default:
      return state;
  }
}
